@import '../../../assets/styles/theme';

.input {
  height: 36px;
  font-size: 14px;
  background-color: white;
  border: 1px solid $primary;
  border-radius: 4px;
  padding: 4px 12px 4px 14px;
  transition: box-shadow 0.3s, border 0.5s;
  &:focus {
    outline: none;
    border: 1px solid $orange-500;
    border-bottom-left-radius: 4;
    border-top-left-radius: 4;
    box-shadow: inset 0.3em 0 0 0 $orange-500;
  }
  &:disabled {
    background-color: $secondary;
    pointer-events: none;
  }
}
